import React, { Component, lazy, Suspense } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import axios from "axios"
import jwt_decode from 'jwt-decode'
import { GetBaseUrl } from '@/utils/ConfigHelper'
import { mode } from "webconfig"
import qs from 'query-string'
import i18n from "./i18n"
import { connect } from 'react-redux'
import { REDUX_ACTION } from './Redux/action'
import DataManager from '@/utils/DataManager'
import { TrackingVideo09Visit } from "@/utils/AnalyticsHelper"
import ReactGA from 'react-ga'
import ReduxInstance, { ReduxBinding } from './Redux/instance'
import { isMobile, isMacOs } from 'react-device-detect'

import "./App.scss"

import "./styles/global_color.scss"
import "./SignUp/SignUp.scss"
import "./Login/Login.scss"
import "./Payment/Charge/paycomponent/detail.scss"

// import { GetRegionByCountryCode, TraceUSRegion, SetConfig } from '@/utils/ConfigHelper'
import { SetLanguage } from '@/utils/LangHelper'

import VideomonsterRenderer from "./RenderComponent/Videomonster"
import WadizRenerer from "./RenderComponent/Wadiz"
import Cafe24Renderer from "./RenderComponent/Cafe24"
import Video09Renderer from "./RenderComponent/Video09"

import MobileRenderer from "@/_mobile"
import Loading from '@/Common/loading/loading'
import { Interface } from "./Interface"

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"

dayjs.extend(utc);

class App extends Component {
  isMobile

  state = {
    isTraceCompleted: false
  }

  constructor(props) {
    super(props);

    this.currentLocation = null
    this.isMobile = this.mobilecheck()

    this.fetchUserCountryCode()
  }

  fetchUserCountryCode = async () => {
    try {
      const { data } = await axios.get('https://www.cloudflare.com/cdn-cgi/trace')

      if (typeof data === 'string') {
        const dataArr = data.split('\n')
        for (let i = 0; i < dataArr.length; i++) {
          const [key, value] = dataArr[i].split('=')

          if (key === 'loc') {
            sessionStorage.setItem('country', value)

            // NOTE :: US Region을 삭제하여 사용하지 않게됨

            // const region = await GetRegionByCountryCode(value)
            // SetConfig(region)
            // console.log('region : ' + region)

            // 국가코드 -> US일 경우
            // 1차적으로 위에서 API 서버 US로 먼저 설정 후, TraceUSRegion 실행하여 더 가까운 API server로 연결
            // (페이지 로딩에 영향을 덜 받기 위해 10초 이후 실행)
            // if (value === 'US') {
            //   setTimeout(async () => {
            //     const nearestRegion = await TraceUSRegion()
            //     SetConfig(nearestRegion)
            //     console.log('nearestRegion : ' + nearestRegion)
            //   }, 10000)
            // }
            break
          }
        }
      }
    }
    catch (e) {
      console.log(e)
    }

    this.setState({
      isTraceCompleted: true
    })
  }

  listenLocationChange = (props) => {
    if (this.currentLocation !== props.location.pathname) {
      this.currentLocation = props.location.pathname
      ReduxBinding(REDUX_ACTION.CURRENT_PATH_STATE, this.currentLocation)

      if (mode === 'stage') {
        ReactGA.pageview('/' + props.location.pathname.split('/')[1])
        // ReactPixel.pageView('/' + props.location.pathname.split('/')[1])
      }
    }
  }

  mobilecheck = () => {
    // TODO :: 추후 삭제 예정
    // var check = false;
    // (function (a) {
    //   if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    // })(navigator.userAgent || navigator.vendor || window.opera);
    // const { userAgent } = navigator

    // check = check || userAgent.match(/iPad/i) != null //아이패드 체크
    // check = check || userAgent.match(/VM_ANDROID_APP|android/i) != null //안드로이드앱, 갤럭시탭 등 체크
    // return check

    //IOS기기 데스크탑 보기 모드 지원을 위해서 isMacOs값 검사 추가
    return (isMobile && !isMacOs);
  }

  SendAppErrorLog = param => {
    try {
      let id = undefined
      const token = localStorage.getItem('token')
      if (token) {
        const decoded = jwt_decode(token)
        if (decoded) id = decoded._id
      }

      const { log, deviceInfo } = param
      axios.post(`${GetBaseUrl()}/api/system/app-error-log`, {
        id,
        log,
        deviceInfo
      }).catch(() => { })
    }
    catch (e) {

    }
  }

  async componentDidMount() {
    window.oncontextmenu = function (event) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }

    if (window.setCustomEventListener) {
      window.setCustomEventListener('send_app_error_log', this.SendAppErrorLog)
    }
    if (this.isMobile) return
  }

  componentWillUnmount() {
    if (window.removeCustomEventListener) {
      window.removeCustomEventListener('send_app_error_log')
    }
  }

  changeLanguage = (e) => {
    const select = document.getElementById("selectLanguage-wrap");
    let newlang = e.target.value
    SetLanguage(newlang)

    select.blur()
  }

  handleClickBandBanner = () => { }

  renderVideomonsterComponent = () => {
    return (
      <VideomonsterRenderer
        isMobile={this.isMobile}
        changeLanguage={this.changeLanguage}
        listenLocationChange={this.listenLocationChange}
        {...this.props}
      />
    )
  }

  renderWadizComponent = () => {
    return (
      <WadizRenerer
        isMobile={this.isMobile}
        changeLanguage={this.changeLanguage}
        listenLocationChange={this.listenLocationChange}
        {...this.props}
      />
    )
  }

  renderCafe24Component = () => {
    return (
      <Cafe24Renderer
        isMobile={this.isMobile}
        changeLanguage={this.changeLanguage}
        listenLocationChange={this.listenLocationChange}
        {...this.props}
      />
    )
  }

  renderVideo09Component = () => {
    return (
      <Video09Renderer
        isMobile={this.isMobile}
        listenLocationChange={this.listenLocationChange}
        {...this.props}
      />
    )
  }

  redirectIfFromLocalePath = () => {
    const { location: { pathname, search } } = window

    // /ko-KR/designselect => [ "", "ko-KR", "designselect" ]
    const arr = pathname.split('/')
    const locale = arr[1] // ko-KR

    // string replace => /ko-KR/designselect -> /designselect
    const replacedUrl = `${pathname.replace(`/${locale}`, '')}${search}`

    return <Redirect to={replacedUrl} />
  }

  render() {
    const { isMobile } = this
    const { isTraceCompleted } = this.state

    if (!isTraceCompleted) return <Loading />

    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    if (query.provider) {
      DataManager.SetProvider(query.provider)
      // if (query.provider === DataManager.PROVIDER.VIDEO09 && query.spot) {
      //   sessionStorage.setItem("spot", query.spot)
      //   TrackingVideo09Visit(query.spot)
      // }
    }
    // EVENT LOGIC START
    if (query.naverpay) {
      sessionStorage.setItem("naverpay", true)
    }
    // EVENT LOGIC END

    let renderComponentFunc
    const provider = sessionStorage.getItem("provider")
    const { currentUser } = this.props
    if (currentUser && currentUser.type === 'cafe24') {
      DataManager.SetProvider(DataManager.PROVIDER.CAFE24)
      renderComponentFunc = this.renderCafe24Component
    }
    else {
      // if (provider === DataManager.PROVIDER.WADIZ) renderComponentFunc = this.renderWadizComponent
      if (provider === DataManager.PROVIDER.CAFE24) renderComponentFunc = this.renderCafe24Component
      // else if (provider === DataManager.PROVIDER.VIDEO09) renderComponentFunc = this.renderVideo09Component
      else renderComponentFunc = this.renderVideomonsterComponent
    }

    return (
      <div className="app">
        <ReduxInstance />
        {isMobile
          ?
          provider === "cafe24" || (currentUser && currentUser.type === 'cafe24')
            ?
            <>
              <Interface
                isMobile={isMobile}
                changeLanguage={this.changeLanguage}
                listenLocationChange={this.listenLocationChange}
                {...this.props}
              />
              {this.renderCafe24Component()}
            </>
            : <MobileRenderer  {...this.props} />
          : 
          <Suspense fallback={
            !window.location.pathname.startsWith('/admin') ?
              <>
                <div style={{ width: '100vw', height: '100vh' }}>
                  <Loading />
                </div>
              </>
              :
              <div></div>
          }>
            {!window.location.pathname.startsWith('/admin') && <Interface
              isMobile={isMobile}
              changeLanguage={this.changeLanguage}
              listenLocationChange={this.listenLocationChange}
              {...this.props}
            />}
            {renderComponentFunc()}
          </Suspense>
        }
        <Route path={`/ko-KR`} component={() => this.redirectIfFromLocalePath()} />
        <Route path={`/en-US`} component={() => this.redirectIfFromLocalePath()} />
        <Route path={`/ja-JP`} component={() => this.redirectIfFromLocalePath()} />
        <Route path={`/vi-VN`} component={() => this.redirectIfFromLocalePath()} />
        <Route path={`/th-TH`} component={() => this.redirectIfFromLocalePath()} />
        <Route path={`/id-ID`} component={() => this.redirectIfFromLocalePath()} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.userStore.user,
})

export default connect(
  mapStateToProps,
  null,
  null
)(App);